import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { CenterFlexRow, FlexRow } from "styles/layout";
import { BURGER_MENU_VISIBLE_FROM, Theme } from "theme";

export const NavBarContainer = styled.nav`
  background-color: ${Theme.navBackground};
`;

export const NavOptions = styled.div`
  display: flex;
  flex-direction: row;
  height: 45px;
  line-height: 45px;
`;

/* Display media query on container div since display didn't work on styled(BurgerMenu) */
export const BurgerMenuContainer = styled.div`
  display: flex;

  @media (min-width: ${BURGER_MENU_VISIBLE_FROM}) {
    display: none;
  }
`;

export const HomeNavItem = styled(NavLink)`
  cursor: pointer;
  padding: 5px 25px;
  display: flex;
  &:hover {
    filter: brightness(1.1) drop-shadow(0 0 30px ${Theme.navHomeHover});
    transform: scale(1.02);
  }

  @media (max-width: ${BURGER_MENU_VISIBLE_FROM}) {
    margin-left: 5px;
  }
`;

export const LogoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

export const NavItem = styled(NavLink)`
  font-size: 13pt;
  text-align: center;
  color: ${Theme.navForeground};
  padding: 0 20px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: ${Theme.navHoverBackground};
    color: ${Theme.navHoverForeground};
  }

  &.active {
    background: ${Theme.navActiveBackground};
    color: ${Theme.navActiveForeground};
    border-bottom: 2px solid ${Theme.navActiveForeground};

    &:hover {
      background: ${Theme.navActiveHoverBackground};
    }
  }

  display: none;
  @media (min-width: ${BURGER_MENU_VISIBLE_FROM}) {
    display: block;
  }
`;

export const NavBarAccountContainer = styled.div`
  margin-left: auto;
  height: 100%;
`;

export const LoginButton = styled.button`
  background: lightgray;
  border-radius: 8px;
  border: 0.5px solid black;
  cursor: pointer;
  padding: 4px 8px;
  margin: 8px;
  font-size: 11pt;
  &:hover {
    background: MediumSeaGreen;
  }
`;

export const PatreonContainer = styled(FlexRow)`
  width: 100%;
  background-color: ${Theme.navSecondaryBackground};
  color: white;
  border-top: 1px solid white;
`;

export const PatreonContainerContents = styled.div`
  margin: auto;
  padding: 4px 0px 6px 0px;
`;

export const Prefix = styled.span`
  @media (max-width: 600px) {
    display: none;
  }
`;
export const PatreonText = styled.a`
  color: #fb8065;
  font-weight: bold;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const DiscordText = styled.a`
  color: rgb(113, 124, 243);
  font-weight: bold;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
